import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Home from './Home';
import Admin from './Admin';

function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={ Home } />
      <Route exact path="/admin" component={ Admin } />
    </Switch>
  );
}

export default Routes;
